import Route from 'mewe/routes/route';
import { Theme } from 'mewe/constants';
import {
  getAnalyticsFeed,
  fetchAnalyticsFeed,
  fetchMoreAnalyticsFeed,
  fetchAnalyticsOverview,
  getAnalyticsOverview,
} from 'mewe/fetchers/fetch-page-analytics';

export let PageAnalyticsWithPostsBase = Route.extend({
  theme: Theme.PAGE,
  leaf: true,

  showFollowersInOverview: true,

  queryParams: {
    to: {
      refreshModel: true,
    },
  },

  id() {
    return this.modelFor('app.publicid').page.id;
  },

  beforeModel(transition) {
    const queryParams = (transition.intent && transition.intent.queryParams) || {},
      to = queryParams.to || 7,
      now = new Date(),
      ref = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 0, 0, 0) - to * 24 * 60 * 60 * 1000,
      id = this.id();

    fetchAnalyticsFeed(id, { ref });
    fetchAnalyticsOverview(id, { interval: to, followers: this.showFollowersInOverview });
  },

  model(params) {
    const id = this.id();

    return {
      app: this.modelFor('app'),
      page: this.modelFor('app.publicid').page,
      feed: getAnalyticsFeed(id),
      overview: getAnalyticsOverview(id, { interval: params.to || 7 }),
    };
  },

  actions: {
    refreshFeed() {
      this.refresh();
    },

    selectDateRange(range) {
      this.controller.set('to', range.range);
    },

    loadMorePosts() {
      const feed = getAnalyticsFeed(this.id());

      if (feed.nextPage && !feed.isFetching) fetchMoreAnalyticsFeed(this.id());
    },
  },
});

export default PageAnalyticsWithPostsBase;
